// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const accelgor: PokeData = {
  "id": 617,
  "name": "accelgor",
  "height": 8,
  "weight": 253,
  "base_experience": 173,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "body-slam",
    "acid",
    "absorb",
    "mega-drain",
    "toxic",
    "agility",
    "quick-attack",
    "double-team",
    "recover",
    "swift",
    "leech-life",
    "acid-armor",
    "curse",
    "giga-drain",
    "yawn",
    "u-turn",
    "me-first",
    "power-swap",
    "guard-swap",
    "bug-buzz",
    "acid-spray",
    "final-gambit",
    "struggle-bug",
    "water-shuriken"
  ],
  "moves": [
    "body-slam",
    "acid",
    "quick-attack",
    "curse",
    "bug-buzz",
    "leech-steal",
    "bug-bite",
    "pounce",
    "signal-spam",
    "infest",
    "pin-rush",
    "string-shot",
    "sticky-web"
  ],
  "evolution_chain": {
    "id": 312,
    "item": null,
    "species": [
      {
        "name": "shelmet",
        "order": 617,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "accelgor",
        "order": 618,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": 616,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": 588,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 84,
    "speed": 187,
    "ability_power": 129
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
